import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFilters, getVisibleReportGroups } from "./reportSelectors";
import * as reportActions from "./reportActions";
import PageTitle from "../common/text/PageTitle";
import Filter from "../common/Filter";
import ReportLink from "./ReportLink";
import Spinner from "../common/progress/Spinner";
import PageErrorMessage from "../common/PageErrorMessage";
import _ from "lodash";
import translate from "react-i18next/dist/commonjs/translate";

class ReportsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      sortKey: "",
      sortDirection: ""
    };
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleDownloadReport = this.handleDownloadReport.bind(this);
    this.handleSortByTitle = this.handleSortByTitle.bind(this);
    this.handleSortByPeriod = this.handleSortByPeriod.bind(this);
    this.handleSortByGenerated = this.handleSortByGenerated.bind(this);
  }

  componentWillMount() {
    this.props.actions.loadReports();
  }

  handleFilterClick(value) {
    this.props.actions.selectFilter(value);
  }

  onReload() {
    this.props.actions.loadReports();
  }

  handleDownloadReport(reportId, filename) {
    this.props.actions.downloadReport(reportId, filename);
  }

  handleSortByTitle() {
    this.setState(prevState => {
      const direction =
        prevState.sortKey === "title" && prevState.sortDirection === "asc"
          ? "desc"
          : "asc";
      return {
        sortKey: "title",
        sortDirection: direction
      };
    });
  }

  handleSortByPeriod() {
    this.setState(prevState => {
      const direction =
        prevState.sortKey === "period" && prevState.sortDirection === "asc"
          ? "desc"
          : "asc";
      return {
        sortKey: "period",
        sortDirection: direction
      };
    });
  }

  handleSortByGenerated() {
    this.setState(prevState => {
      const direction =
        prevState.sortKey === "generated" && prevState.sortDirection === "asc"
          ? "desc"
          : "asc";
      return {
        sortKey: "generated",
        sortDirection: direction
      };
    });
  }

  render() {
    const { t, visibleReportGroups } = this.props;
    const sortedReports = _.orderBy(
      visibleReportGroups,
      [this.state.sortKey],
      [this.state.sortDirection]
    );
    if (this.props.isLoading) {
      return (
        <div className="my-nodes-page">
          <section className="main-content">
            <PageTitle text={t("reportsPageTitle")} />
            <div className="container">
              <div className="text-center">
                <Spinner />
              </div>
            </div>
          </section>
        </div>
      );
    }

    if (this.props.hasErrors) {
      return (
        <div className="my-nodes-page">
          <section className="main-content">
            <PageTitle text={t("reportsPageTitle")} />
            <div className="container">
              <div className="text-center">
                <PageErrorMessage onReload={this.onReload} />
              </div>
            </div>
          </section>
        </div>
      );
    }

    return (
      <div className="my-nodes-page">
        <section className="main-content">
          <PageTitle text={t("reportsPageTitle")} />
          <div className="container">
            {t("reportsPageHeaderTitle")}:{" "}
            {this.props.filters.map((f, i) => (
              <Filter
                key={i}
                value={f.key}
                handleClick={this.handleFilterClick}
                isSelected={f.isSelected}
              />
            ))}
            <table className="table table-responsive table-hover table-sortable table-ui">
              <thead>
                <tr>
                  <th onClick={this.handleSortByGenerated} className="col-md-3">
                    {t("reportsPageHeaderGenerated")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortByTitle} className="col-md-4">
                    {t("reportsPageHeaderTitle")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th onClick={this.handleSortByPeriod} className="col-md-4">
                    {t("reportsPageHeaderPeriod")}
                    <i className="fa fa-sort pull-right text-muted" />
                  </th>
                  <th className="col-md-1" />
                </tr>
              </thead>
              <tbody>
                {sortedReports.map((report, index) => {
                  return (
                    <tr key={index}>
                      <td>{report.generated}</td>
                      <td>{report.title}</td>
                      <td>{report.period}</td>
                      <td>
                        <ReportLink
                          clickHandler={this.handleDownloadReport}
                          filename={report.filename}
                          reportId={report.id}
                          linkText={t("reportsPageDownload")}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    );
  }
}

ReportsPage.propTypes = {
  reports: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
  visibleReportGroups: PropTypes.array.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    reports: state.reports,
    filters: getFilters(state),
    hasErrors: state.reportHasErrors,
    visibleReportGroups: getVisibleReportGroups(state),
    isLoading: state.reportsIsLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(reportActions, dispatch)
  };
}

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportsPage)
);



// WEBPACK FOOTER //
// ./src/reports/ReportsPage.js